import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_036.jpg';
page.images = [
  {
    imageId: 'page036_zoom0',
    rectangle: {
      x: 980,
      y: 1658,
      width: 796,
      height: 630,
    },
    imageSrc: 'images/page036/036 6.jpg',
  },
  {
    imageId: 'page036_zoom1',
    rectangle: {
      x: 136,
      y: 1658,
      width: 808,
      height: 632,
    },
    imageSrc: 'images/page036/036 5.jpg',
  },
  {
    imageId: 'page036_zoom2',
    rectangle: {
      x: 980,
      y: 1000,
      width: 796,
      height: 632,
    },
    imageSrc: 'images/page036/036 4.jpg',
  },
  {
    imageId: 'page036_zoom3',
    rectangle: {
      x: 140,
      y: 990,
      width: 802,
      height: 632,
    },
    imageSrc: 'images/page036/036 3.jpg',
  },
  {
    imageId: 'page036_zoom4',
    rectangle: {
      x: 980,
      y: 338,
      width: 794,
      height: 628,
    },
    imageSrc: 'images/page036/036 2.jpg',
  },
  {
    imageId: 'page036_zoom5',
    rectangle: {
      x: 136,
      y: 330,
      width: 806,
      height: 634,
    },
    imageSrc: 'images/page036/036 1.jpg',
  },
];
page.paint = [
  {
    id: 'page018_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Wykonaj obrazek przedstawiający aktualną porę roku.  ',
      audio: 'files/page018/z18c3.mp3',
      item: {
        path: 'informatyka/files/page018/z.18cw.3.bmp',
      },
      cssStyle: {
        height: 'auto',
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
  {
    id: 'page018_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Usuń niepotrzebne elementy rysunku.  ',
      audio: 'files/page018/z18c2.mp3',
      item: {
        path: 'informatyka/files/page018/z.18cw.2.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
];
page.games = [
  {
    id: 'page018_game0',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  // {
  //   id: 'page010_game2',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 200,
  //   },
  // },
  // {
  //   id: 'page010_game3',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 400,
  //   },
  // },
  // {
  //   id: 'page010_game4',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 600,
  //   },
  // },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: RIGHT,
  //     y: 800,
  //   },
  // },
];
export default page;
